import React, { FC, useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';
import { FormComposedProps } from './Form';

const withFormReducerKey = <Values, >(WrappedComponent: FC<FormComposedProps<Values>>) => {
  const WithFormReducerKey = (props: FormComposedProps<Values>) => {
    const { name, parentFormScope = [] } = props;
    const formReducerKey = useMemo(() => (
      (parentFormScope.length) ?
        [...parentFormScope, name].join('.forms.') :
        name
    ), [name, parentFormScope]);

    return (
      <WrappedComponent
        {...props}
        formReducerKey={formReducerKey}
      />
    );
  };

  WithFormReducerKey.displayName = getWrappedDisplayName('WithFormReducerKey', WrappedComponent);

  return hoistNonReactStatics(WithFormReducerKey, WrappedComponent);
};

export default withFormReducerKey;
